module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_9005.24963389.png";